fragment Client on Client {
    _id
    id
    name
    logoUrl
    imageProcessingEnabled
    distributionChannel
    creativeXPlatformSettings {
        enabled
        brandId
        threshold
        secretId
    }
}
